import * as products from 'app/mocks/data/catalogue/products/list'
import * as fridgesWeight from 'app/mocks/data/machines/all/fridgesWeight'
import * as terminals from 'app/mocks/data/machines/all/terminals'

import { SELECTION_UNKNOWN } from 'app/utils/transactions/sale'

import {
    PaymentMethodSale,
    Sale,
    StatusDisputeSale,
    TypeDisputeSale,
} from 'app/types/transactions/sale'

export const sale1: Sale = {
    id: 1,
    date_time: '2022-02-11T14:00:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: true,
    total: 12,
    amount_credit_card: 12,
    amount_konvives_wallet: 0,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 1,
            price: 1,
        },
        {
            id: 2,
            price: 2,
        },
        {
            id: 3,
            price: 3,
        },
    ],
    cart_discount: {
        id: 1,
        name: 'test',
        price: 5.25,
        discount_amount: 0.34,
        is_participation: true,
        menus: [
            {
                id: 6_946,
                name: 'Bibim K-Do Dessert Offert 1',
                price: 13.4,
                unit: '?',
                tva: 5.5,
                employer_participation: false,
                products: [
                    {
                        id: 1,
                        name: 'Ailerons marinés grillés',
                        price: 4.5,
                        selection: 'A11',
                        price_paid: 3.5,
                        tva: 5.5,
                        dlc: '2024-07-02',
                        product: {
                            id: 2,
                            name: 'Ailerons marinés grillés',
                        },
                    },
                    {
                        id: 2,
                        name: 'Bibimbap au magret de canard',
                        price: 9.9,
                        selection: SELECTION_UNKNOWN,
                        price_paid: 4.5,
                        tva: 5.5,
                        dlc: '2024-07-03',
                        product: {
                            id: 3,
                            name: 'Bibimbap au magret de canard',
                        },
                    },
                    {
                        id: 3,
                        name: 'Tiramisu au matcha et biscuit rose de Reims',
                        price: 3,
                        selection: 'A13',
                        price_paid: 4.5,
                        tva: 5.5,
                        dlc: '2024-07-01',
                        product: {
                            id: 4,
                            name: 'Tiramisu au matcha et biscuit rose de Reims',
                        },
                    },
                ],
            },
        ],
        discounts: [
            {
                id: 876_398,
                name: 'Il faut manger aujourd’hui ! :)',
                price: 2.1,
                unit: '€',
                tva: 5.5,
                products: [
                    {
                        id: 4,
                        name: 'Entremet choco vegan au piment',
                        price: 3,
                        selection: 'A14',
                        price_paid: 4.5,
                        tva: 5.5,
                        dlc: '2024-06-29',
                        product: {
                            id: 5,
                            name: 'Entremet choco vegan au piment',
                        },
                    },
                ],
            },
        ],
        products: [
            {
                id: 5,
                name: 'Poulet croustillant pomme-miel',
                price: 4.6,
                selection: 'A15',
                price_paid: 4.6,
                tva: 5.5,
                dlc: '2024-07-04',
                product: {
                    id: 6,
                    name: 'Poulet croustillant pomme-miel',
                },
            },
        ],
    },
    menus: [
        {
            id: 2_645,
            name: 'Menu mock miam',
            price: 1.220_280_943_546_249_6,
            unit: '?',
            tva: 20,
            employer_participation: false,
            products: [
                {
                    id: 6,
                    name: 'Juste Pressé Carotte Pomme',
                    price: 3.99,
                    selection: 'A16',
                    price_paid: 3.42,
                    tva: 20,
                    dlc: '2099-12-12',
                    product: {
                        id: 7,
                        name: 'Juste Pressé Carotte Pomme',
                    },
                },
                {
                    id: 7,
                    name: 'Xtrem Box Carbonara',
                    price: 4,
                    selection: 'A17',
                    price_paid: 4,
                    tva: 20,
                    dlc: '2099-12-12',
                    product: {
                        id: 8,
                        name: 'Xtrem Box Carbonara',
                    },
                },
            ],
        },
    ],
    discounts: [
        {
            id: 26_651_443,
            name: 'Le super nom de ma promo',
            price: 1,
            unit: '€',
            tva: 10,
            products: [
                {
                    id: 8,
                    name: 'Xtrem Box Carbonara',
                    price: 4,
                    selection: 'A18',
                    price_paid: 4,
                    tva: 20,
                    dlc: '2099-12-12',
                    product: {
                        id: 8,
                        name: 'Xtrem Box Carbonara',
                    },
                },
            ],
        },
        {
            id: 26_651_445,
            name: 'Le super nom de ma promo',
            price: 1,
            unit: '€',
            tva: 10,
            products: [
                {
                    id: 9,
                    name: 'Kiwi',
                    price: 2,
                    selection: 'A19',
                    price_paid: 2,
                    tva: 10,
                    dlc: '2023-05-13',
                    product: {
                        id: 9,
                        name: 'Kiwi',
                    },
                },
            ],
        },
        {
            id: 26_651_446,
            name: 'Le super nom de ma promo',
            price: 1,
            unit: '€',
            tva: 10,
            products: [
                {
                    id: 10,
                    name: 'Kiwi',
                    price: 3.04,
                    selection: 'A20',
                    price_paid: 1.95,
                    tva: 10,
                    dlc: '2023-05-13',
                    product: {
                        id: 9,
                        name: 'Kiwi',
                    },
                },
            ],
        },
        {
            id: 26_651_447,
            name: 'Le super nom de ma promo',
            price: 1,
            unit: '€',
            tva: 10,
            products: [
                {
                    id: 11,
                    name: 'Kiwi',
                    price: 3.04,
                    selection: 'A21',
                    price_paid: 1.95,
                    tva: 10,
                    dlc: '2023-05-13',
                    product: {
                        id: 9,
                        name: 'Kiwi',
                    },
                },
            ],
        },
    ],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A22',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [
        {
            id: 1,
            product: products.product1,
            selection: 'B12',
            reason: 'MOTOR',
        },
        {
            id: 2,
            product: products.product1,
            selection: 'B12',
            reason: 'UNKNOWN',
        },
    ],
    icoupons: [
        {
            id: 'AZDA46114',
            amount: 1,
            is_multiple_use: false,
        },
        {
            id: 'JKOOd12a',
            amount: 10,
            is_multiple_use: true,
        },
    ],
    codes: [
        {
            id: '1654646',
            amount: 5,
            is_percentage: true,
        },
        {
            id: 'BVDA148',
            amount: 1,
            is_percentage: false,
        },
        {
            id: 'BZED156a',
            amount: 10,
            is_percentage: true,
        },
    ],
}

export const sale2: Sale = {
    id: 2,
    date_time: '2023-02-20T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: true,
    total: 0,
    amount_credit_card: 0,
    amount_konvives_wallet: 0,
    discount_amount: 2,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 2,
            price: 12.3,
        },
        {
            id: 3,
            price: 7,
        },
    ],
    menus: [],
    discounts: [],
    products: [],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale3: Sale = {
    id: 3,
    date_time: '2023-03-04T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: true,
    total: 12,
    amount_credit_card: 12,
    amount_konvives_wallet: 0,
    participation: 1,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 3,
            price: 5,
        },
        {
            id: 4,
            price: 22,
        },
    ],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A23',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [
        {
            id: 'AZDA46114',
            amount: 1,
            is_multiple_use: false,
        },
        {
            id: 'JKOOd12a',
            amount: 10,
            is_multiple_use: true,
        },
    ],
    codes: [
        {
            id: '1654646',
            amount: 5,
            is_percentage: true,
        },
        {
            id: 'BVDA148',
            amount: 1,
            is_percentage: false,
        },
        {
            id: 'BZED156a',
            amount: 10,
            is_percentage: true,
        },
    ],
}

export const sale4: Sale = {
    id: 4,
    date_time: '2023-03-09T14:44:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.CASH,
    sale_ok: true,
    total: 18,
    amount_credit_card: 0,
    amount_konvives_wallet: 0,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A24',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [
        {
            id: 'AZDA46114',
            amount: 1,
            is_multiple_use: false,
        },
        {
            id: 'JKOOd12a',
            amount: 10,
            is_multiple_use: true,
        },
    ],
    codes: [
        {
            id: '1654646',
            amount: 5,
            is_percentage: true,
        },
        {
            id: 'BVDA148',
            amount: 1,
            is_percentage: false,
        },
        {
            id: 'BZED156a',
            amount: 10,
            is_percentage: true,
        },
    ],
}

export const sale5: Sale = {
    id: 5,
    date_time: '2023-03-20T14:00:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.KONVIVES,
    sale_ok: false,
    amount_credit_card: 0,
    amount_konvives_wallet: 10,
    total: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 4,
            price: 4,
        },
        {
            id: 5,
            price: 5,
        },
        {
            id: 6,
            price: 6,
        },
    ],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A25',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.REFUNDED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.CLOSED_LOCKER,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [
        {
            id: 'AZDA46114',
            amount: 1,
            is_multiple_use: false,
        },
        {
            id: 'JKOOd12a',
            amount: 10,
            is_multiple_use: true,
        },
    ],
    codes: [
        {
            id: '1654646',
            amount: 5,
            is_percentage: true,
        },
        {
            id: 'BVDA148',
            amount: 1,
            is_percentage: false,
        },
        {
            id: 'BZED156a',
            amount: 10,
            is_percentage: true,
        },
    ],
}

export const sale6: Sale = {
    id: 6,
    date_time: '2023-04-20T13:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight2,
    payment_method: PaymentMethodSale.enum.KONVIVES,
    sale_ok: false,
    amount_credit_card: 0,
    amount_konvives_wallet: 10,
    total: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A26',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.REFUNDED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.MENU_NOT_TAKEN,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [
        {
            id: 'AZDA46114',
            amount: 1,
            is_multiple_use: false,
        },
        {
            id: 'JKOOd12a',
            amount: 10,
            is_multiple_use: true,
        },
    ],
    codes: [
        {
            id: '1654646',
            amount: 5,
            is_percentage: true,
        },
        {
            id: 'BVDA148',
            amount: 1,
            is_percentage: false,
        },
        {
            id: 'BZED156a',
            amount: 10,
            is_percentage: true,
        },
    ],
}

export const sale7: Sale = {
    id: 7,
    date_time: '2023-05-16T14:12:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.KONVIVES,
    sale_ok: false,
    amount_credit_card: 0,
    amount_konvives_wallet: 10,
    total: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A27',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.REFUNDED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.NUMBER_PRODUCTS,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [
        {
            id: 'AZDA46114',
            amount: 1,
            is_multiple_use: false,
        },
        {
            id: 'JKOOd12a',
            amount: 10,
            is_multiple_use: true,
        },
    ],
    codes: [
        {
            id: '1654646',
            amount: 5,
            is_percentage: true,
        },
        {
            id: 'BVDA148',
            amount: 1,
            is_percentage: false,
        },
        {
            id: 'BZED156a',
            amount: 10,
            is_percentage: true,
        },
    ],
}

export const sale8: Sale = {
    id: 8,
    date_time: '2023-05-20T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.KONVIVES,
    sale_ok: false,
    amount_credit_card: 0,
    amount_konvives_wallet: 10,
    total: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 8,
            price: 8,
        },
    ],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A28',
            price_paid: 7,
            product: products.product1,
        },
    ],
    menus: [],
    discounts: [],
    status_dispute: StatusDisputeSale.enum.REFUNDED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.OTHER,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale9: Sale = {
    id: 9,
    date_time: '2023-05-22T15:00:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: true,
    total: 12,
    amount_credit_card: 12,
    amount_konvives_wallet: 0,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    menus: [],
    discounts: [],
    orders: [
        {
            id: 9,
            price: 9,
        },
        {
            id: 10,
            price: 10,
        },
    ],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A29',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale10: Sale = {
    id: 10,
    date_time: '2023-06-04T14:44:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.KONVIVES,
    sale_ok: true,
    pspReference: 'POLQKDOIA125',
    amount_credit_card: 5,
    amount_konvives_wallet: 3,
    total: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A30',
            price_paid: 7,
            product: products.product1,
        },
    ],
    menus: [],
    discounts: [],
    orders: [],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale11: Sale = {
    id: 11,
    date_time: '2023-10-12T15:00:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.CASH,
    sale_ok: false,
    total: 8,
    amount_credit_card: 0,
    amount_konvives_wallet: 0,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A31',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.REFUNDED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.WRONG_PRICE,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale12: Sale = {
    id: 12,
    date_time: '2023-11-08T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight2,
    payment_method: PaymentMethodSale.enum.CASH,
    sale_ok: true,
    total: 3,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    amount_credit_card: 0,
    amount_konvives_wallet: 0,
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A32',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale13: Sale = {
    id: 13,
    date_time: '2024-02-17T14:12:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: false,
    total: 4,
    amount_credit_card: 4,
    amount_konvives_wallet: 0,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 13,
            price: 13,
        },
        {
            id: 14,
            price: 14,
        },
        {
            id: 15,
            price: 15,
        },
    ],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A33',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.DISPUTED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.WRONG_PRODUCT,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale14: Sale = {
    id: 14,
    date_time: '2024-03-10T13:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: true,
    total: 3,
    pspReference: 'QPSLFSF8JK33BWV5',
    amount_credit_card: 2,
    amount_konvives_wallet: 1,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A34',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale15: Sale = {
    id: 15,
    date_time: '2024-04-18T14:00:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: false,
    total: 18,
    amount_credit_card: 18,
    amount_konvives_wallet: 0,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 15,
            price: 15,
        },
    ],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A35',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.IN_PROGRESS,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.WRONG_PRODUCT,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale16: Sale = {
    id: 16,
    date_time: '2024-05-09T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: true,
    total: 7,
    amount_credit_card: 7,
    amount_konvives_wallet: 0,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 16,
            price: 16,
        },
        {
            id: 17,
            price: 17,
        },
    ],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A36',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale17: Sale = {
    id: 17,
    date_time: '2024-06-15T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight2,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: false,
    total: 3,
    amount_credit_card: 0,
    amount_konvives_wallet: 3,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A37',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.IN_PROGRESS,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.WRONG_PRODUCT,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale18: Sale = {
    id: 18,
    date_time: '2024-07-20T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight2,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: true,
    total: 6,
    pspReference: 'QPSLFSF8JK33BWVDDq4',
    amount_credit_card: 3,
    amount_konvives_wallet: 3,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A38',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale19: Sale = {
    id: 19,
    date_time: '2024-08-11T14:00:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: true,
    total: 13,
    pspReference: 'DqzDADs52',
    amount_credit_card: 3,
    amount_konvives_wallet: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A39',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale20: Sale = {
    id: 20,
    date_time: '2024-08-18T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: false,
    total: 12,
    amount_credit_card: 12,
    amount_konvives_wallet: 0,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A40',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.REFUNDED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.WRONG_PRODUCT,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale21: Sale = {
    id: 21,
    date_time: '2024-08-21T14:44:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.KONVIVES,
    sale_ok: true,
    pspReference: 'DDQDJOIADQ',
    amount_credit_card: 10,
    amount_konvives_wallet: 0,
    total: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A41',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale22: Sale = {
    id: 22,
    date_time: '2024-08-22T14:44:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.KONVIVES,
    sale_ok: true,
    amount_credit_card: 0,
    amount_konvives_wallet: 8,
    total: 8,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A42',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale23: Sale = {
    id: 23,
    date_time: '2024-09-10T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight2,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: true,
    pspReference: 'DAdad788ad44ad',
    total: 3,
    amount_credit_card: 3,
    amount_konvives_wallet: 0,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A43',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale24: Sale = {
    id: 24,
    date_time: '2024-09-18T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: false,
    total: 4,
    amount_credit_card: 4,
    amount_konvives_wallet: 0,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A44',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.CONTACTED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.WRONG_PRODUCT,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale25: Sale = {
    id: 25,
    terminal: fridgesWeight.fridgeWeight1,
    date_time: '2024-10-10T14:44:40+02:00',
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: false,
    total: 3,
    amount_credit_card: 0,
    amount_konvives_wallet: 3,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A45',
            price_paid: 7,
            product: products.product1,
        },
    ],
    status_dispute: StatusDisputeSale.enum.DISPUTED,
    dispute_sale: {
        datetime: '2024-09-02T18:15:23.505435+02:00',
        email: 'sdf@sdf.com',
        type: TypeDisputeSale.enum.WRONG_PRODUCT,
        products: [],
    },
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale26: Sale = {
    id: 26,
    date_time: '2024-10-12T14:44:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: true,
    total: 18,
    amount_credit_card: 18,
    amount_konvives_wallet: 0,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A46',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale27: Sale = {
    id: 27,
    date_time: '2024-10-19T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight1,
    payment_method: PaymentMethodSale.enum.CREDIT_CARD,
    sale_ok: true,
    total: 7,
    amount_credit_card: 7,
    amount_konvives_wallet: 0,
    pan: '9999########9999',
    max_auth: 10,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A47',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale28: Sale = {
    id: 28,
    date_time: '2024-10-22T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight2,
    payment_method: PaymentMethodSale.enum.CASH,
    sale_ok: true,
    total: 3,
    amount_credit_card: 0,
    amount_konvives_wallet: 0,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A48',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale29: Sale = {
    id: 29,
    date_time: '2024-10-27T14:44:40+02:00',
    terminal: fridgesWeight.fridgeWeight2,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: true,
    total: 6,
    pspReference: 'DADSPPA15574DA',
    amount_credit_card: 2,
    amount_konvives_wallet: 4,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A49',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}

export const sale30: Sale = {
    id: 30,
    date_time: '2024-10-28T11:44:40+02:00',
    terminal: terminals.terminal1,
    payment_method: PaymentMethodSale.enum.PRIVATE_CARD,
    sale_ok: true,
    total: 13,
    pspReference: 'PKKSADS5456',
    amount_credit_card: 12,
    amount_konvives_wallet: 1,
    acceptation_date: '2024-10-22T12:16:41.892355+02:00',
    orders: [
        {
            id: 30,
            price: 30,
        },
        {
            id: 31,
            price: 31,
        },
    ],
    menus: [],
    discounts: [],
    products: [
        {
            ...products.product1,
            id: 12,
            selection: 'A50',
            price_paid: 7,
            product: products.product1,
        },
    ],
    products_not_distributed: [],
    icoupons: [],
    codes: [],
}
